import { Dispatch } from "redux";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";
import { SavedMessage } from "../../../../../models";
import { processSavedMessagesResponse } from "./processSavedMessagesResponse";

export interface GetSavedMessagesAdditionalData {
    messagesPage?: number,
    userId: string,
}

export const getSavedMessagesActionTypes = createRequestActionTypes('GET_SAVED_MESSAGES')

export const getSavedMessages = (config: ApiConfig) => (userId: string, page: number) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<SavedMessage[], never, GetSavedMessagesAdditionalData> = {
        method: 'GET',
        requestActionTypes: getSavedMessagesActionTypes,
        url: `${config.API_URL}/savedMessages`,
        actionAdditionalData: {
            userId,
            messagesPage: page
        },
        processResultBeforeDispatch: processSavedMessagesResponse
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}

